import { ProductBadgeFactory } from '../../../../../services/MarppleShop/renderApp/components/cells/ProductBadge/ProductBadgeFactory';
import {
  ProductBadgeSize,
  ProductBadgeType,
} from '../../../../../services/MarppleShop/features/ProductBadge/type';
import { Lang } from '../../../../../types/global';

/**
 * js에서 타입에러가 추적이 안 되니까 말아두었어요
 */
export const createStudioMembershipBadge = (lang: Lang['lang']) => {
  return ProductBadgeFactory.create(ProductBadgeType.MEMBERSHIP, {
    value: undefined,
    option: {
      size: ProductBadgeSize.medium,
      lang,
      ratio: 'square',
    },
  });
};
